import { render, staticRenderFns } from "./swiperList.vue?vue&type=template&id=4f3e0428&scoped=true&"
import script from "./swiperList.vue?vue&type=script&lang=js&"
export * from "./swiperList.vue?vue&type=script&lang=js&"
import style0 from "./swiperList.vue?vue&type=style&index=0&id=4f3e0428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e0428",
  null
  
)

export default component.exports